import type { CheckboxDesignTokens } from '@primeuix/themes/types/checkbox'
import type { RadioButtonDesignTokens } from '@primeuix/themes/types/radiobutton'
import type { RatingDesignTokens } from '@primeuix/themes/types/rating'
import type { ToggleSwitchDesignTokens } from '@primeuix/themes/types/toggleswitch'

import { bothSchemes } from '../utils'

/** Переключатели «Приборы» и «Списать баллы»: 44×28, включённый — жёлтый. */
export const toggleSwitchConfig = (): ToggleSwitchDesignTokens => ({
  root: {
    width: '44px',
    height: '28px',
    borderRadius: 'var(--radius-pill)',
    gap: '2px',
    borderWidth: '0',
    shadow: 'none',
    focusRing: { width: '0', style: 'none', offset: '0' },
    transitionDuration: '.2s',
  },
  handle: {
    size: '24px',
    borderRadius: 'var(--radius-round)',
  },
  colorScheme: bothSchemes({
    root: {
      background: 'var(--surface-muted)',
      hoverBackground: 'var(--secondary-100)',
      checkedBackground: 'var(--accent-500)',
      checkedHoverBackground: 'var(--accent-500)',
      borderColor: 'transparent',
      hoverBorderColor: 'transparent',
      checkedBorderColor: 'transparent',
      checkedHoverBorderColor: 'transparent',
      disabledBackground: 'var(--secondary-100)',
    },
    handle: {
      background: 'var(--white)',
      hoverBackground: 'var(--white)',
      checkedBackground: 'var(--white)',
      checkedHoverBackground: 'var(--white)',
      disabledBackground: 'var(--secondary-300)',
      color: 'var(--white)',
      hoverColor: 'var(--white)',
      checkedColor: 'var(--white)',
      checkedHoverColor: 'var(--white)',
    },
  }),
})

/** Чекбоксы «Приборы» / «Пакет» при оформлении заказа. */
export const checkboxConfig = (): CheckboxDesignTokens => ({
  root: {
    width: '24px',
    height: '24px',
    borderRadius: 'var(--radius-xs)',
    shadow: 'none',
    focusRing: { width: '0', style: 'none', offset: '0' },
    transitionDuration: '.15s',
  },
  icon: {
    size: '14px',
  },
  colorScheme: bothSchemes({
    root: {
      background: 'var(--surface-muted)',
      checkedBackground: 'var(--accent-500)',
      checkedHoverBackground: 'var(--accent-400)',
      disabledBackground: 'var(--secondary-100)',
      filledBackground: 'var(--surface-muted)',
      borderColor: 'var(--secondary-300)',
      hoverBorderColor: 'var(--secondary-400)',
      checkedBorderColor: 'var(--accent-500)',
      checkedHoverBorderColor: 'var(--accent-400)',
      invalidBorderColor: 'var(--primary-500)',
    },
    icon: {
      color: 'var(--text-color)',
      checkedColor: 'var(--accent-surface-color)',
      checkedHoverColor: 'var(--accent-surface-color)',
      disabledColor: 'var(--text-color-secondary)',
    },
  }),
})

/** Радио: выбор пола, способа оплаты, адреса доставки. */
export const radioButtonConfig = (): RadioButtonDesignTokens => ({
  root: {
    width: '24px',
    height: '24px',
    shadow: 'none',
    focusRing: { width: '0', style: 'none', offset: '0' },
    transitionDuration: '.15s',
  },
  icon: {
    size: '10px',
  },
  colorScheme: bothSchemes({
    root: {
      background: 'var(--surface-muted)',
      checkedBackground: 'var(--accent-500)',
      checkedHoverBackground: 'var(--accent-400)',
      disabledBackground: 'var(--secondary-100)',
      filledBackground: 'var(--surface-muted)',
      borderColor: 'var(--secondary-300)',
      hoverBorderColor: 'var(--secondary-400)',
      checkedBorderColor: 'var(--accent-500)',
      checkedHoverBorderColor: 'var(--accent-400)',
      invalidBorderColor: 'var(--primary-500)',
    },
    icon: {
      checkedColor: 'var(--accent-surface-color)',
      checkedHoverColor: 'var(--accent-surface-color)',
      disabledColor: 'var(--text-color-secondary)',
    },
  }),
})

/** Оценка заказа — 5 звёзд, жёлтые. */
export const ratingConfig = (): RatingDesignTokens => ({
  root: {
    gap: 'var(--space-4)',
    transitionDuration: '.15s',
  },
  icon: {
    size: '36px',
  },
  colorScheme: bothSchemes({
    icon: {
      color: 'var(--secondary-200)',
      hoverColor: 'var(--accent-400)',
      activeColor: 'var(--accent-500)',
    },
  }),
})
